export default {
    "v": "5.7.11",
    "fr": 30,
    "ip": 59,
    "op": 119,
    "w": 1080,
    "h": 1080,
    "nm": "Source",
    "ddd": 0,
    "assets": [],
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Tear Left",
        "parent": 9,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 8.708, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.667, "y": 1},
                    "o": {"x": 0.333, "y": 0},
                    "t": 77,
                    "s": [-91.271, 4.207, 0],
                    "to": [-3.485, 12.239, 0],
                    "ti": [3.485, -12.239, 0]
                }, {"t": 86, "s": [-112.18, 77.641, 0]}],
                "ix": 2,
                "l": 2
            },
            "a": {"a": 0, "k": [82, 12.75, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [-156.471, 83.125, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 77,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82.25, 16.75], [82, 16.75]],
                            "c": false
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 80,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82, 8.75], [82, 16.75]],
                            "c": false
                        }]
                    }, {
                        "t": 86,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82.25, 16.75], [82, 16.75]],
                            "c": false
                        }]
                    }],
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0, 0, 0, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 5, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.211765005074, 0.211765005074, 0.211765005074, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 76,
        "op": 87,
        "st": 2,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Tear Right",
        "parent": 9,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.667, "y": 1},
                    "o": {"x": 0.333, "y": 0},
                    "t": 75,
                    "s": [57, 2.75, 0],
                    "to": [1.592, 12.625, 0],
                    "ti": [-1.592, -12.625, 0]
                }, {"t": 84, "s": [66.55, 78.503, 0]}],
                "ix": 2,
                "l": 2
            },
            "a": {"a": 0, "k": [82, 12.75, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [269.412, 143.125, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 75,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82.25, 16.75], [82, 16.75]],
                            "c": false
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 78,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82, 8.75], [82, 16.75]],
                            "c": false
                        }]
                    }, {
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[82.25, 16.75], [82, 16.75]],
                            "c": false
                        }]
                    }],
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0, 0, 0, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 5, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.211765005074, 0.211765005074, 0.211765005074, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 74,
        "op": 85,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Foot Right",
        "parent": 4,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "k": [{"s": [6.584], "t": 59, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [4.396],
                    "t": 60,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [2.181], "t": 61, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-0.044],
                    "t": 62,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-2.26], "t": 63, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-4.448],
                    "t": 64,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-6.59], "t": 65, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-8.667],
                    "t": 66,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-10.66], "t": 67, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-12.552],
                    "t": 68,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-14.323], "t": 69, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-15.955],
                    "t": 70,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-17.429], "t": 71, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.728],
                    "t": 72,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-19.832], "t": 73, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-20.723],
                    "t": 74,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.382], "t": 75, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-21.791],
                    "t": 76,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.932], "t": 77, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-21.772],
                    "t": 78,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.306], "t": 79, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-20.557],
                    "t": 80,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-19.548], "t": 81, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.301],
                    "t": 82,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-16.839], "t": 83, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-15.185],
                    "t": 84,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-13.361], "t": 85, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-11.39],
                    "t": 86,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-9.295], "t": 87, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-7.098],
                    "t": 88,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-4.821], "t": 89, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-2.488],
                    "t": 90,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-0.121], "t": 91, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [2.257],
                    "t": 92,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [4.624], "t": 93, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [6.957],
                    "t": 94,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [9.234], "t": 95, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [11.431],
                    "t": 96,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [13.527], "t": 97, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [15.498],
                    "t": 98,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [17.322], "t": 99, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [18.976],
                    "t": 100,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [20.437], "t": 101, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.684],
                    "t": 102,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [22.693], "t": 103, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [23.442],
                    "t": 104,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [23.908], "t": 105, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [24.068],
                    "t": 106,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [23.928], "t": 107, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [23.518],
                    "t": 108,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [22.859], "t": 109, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.968],
                    "t": 110,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [20.864], "t": 111, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [19.566],
                    "t": 112,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [18.091], "t": 113, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [16.459],
                    "t": 114,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [14.688], "t": 115, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [12.796],
                    "t": 116,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [10.803], "t": 117, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [8.726],
                    "t": 118,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }]
            },
            "p": {"a": 0, "k": [-66.949, 288.907, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [-371, 223.5, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[-410, 226.5], [-370, 222]], "c": false},
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 30, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0, "ind": 4, "ty": 4, "nm": "Leg Right", "parent": 9, "sr": 1, "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "k": [{"s": [-7.953], "t": 59, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-3.994],
                    "t": 60,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [3.994], "t": 62, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [7.953],
                    "t": 63,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [11.84], "t": 64, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [15.621],
                    "t": 65,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [19.259], "t": 66, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [22.72],
                    "t": 67,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [25.967], "t": 68, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [28.966],
                    "t": 69,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [31.68], "t": 70, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [34.074],
                    "t": 71,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [36.113], "t": 72, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [37.76],
                    "t": 73,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [38.981], "t": 74, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [39.739],
                    "t": 75,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [40], "t": 76, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [39.721],
                    "t": 77,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [38.911], "t": 78, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [37.609],
                    "t": 79,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [35.854], "t": 80, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [33.686],
                    "t": 81,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [31.144], "t": 82, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [28.267],
                    "t": 83,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [25.095], "t": 84, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.667],
                    "t": 85,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [18.023], "t": 86, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [14.201],
                    "t": 87,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [10.242], "t": 88, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [6.185],
                    "t": 89,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [2.068], "t": 90, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-2.068],
                    "t": 91,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-6.185], "t": 92, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-10.242],
                    "t": 93,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-14.201], "t": 94, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.023],
                    "t": 95,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.667], "t": 96, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-25.095],
                    "t": 97,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-28.267], "t": 98, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-31.144],
                    "t": 99,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-33.686], "t": 100, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-35.854],
                    "t": 101,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-37.609], "t": 102, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-38.911],
                    "t": 103,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-39.721], "t": 104, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-40],
                    "t": 105,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-39.739], "t": 106, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-38.981],
                    "t": 107,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-37.76], "t": 108, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-36.113],
                    "t": 109,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-34.074], "t": 110, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-31.68],
                    "t": 111,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-28.966], "t": 112, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-25.967],
                    "t": 113,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-22.72], "t": 114, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-19.259],
                    "t": 115,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-15.621], "t": 116, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-11.84],
                    "t": 117,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-7.953], "t": 118, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}]
            },
            "p": {"a": 0, "k": [66, 167, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [-66, 167, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [-100, 100, 100], "ix": 6, "l": 2}
        }, "ao": 0, "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "k": [{
                        "s": [{
                            "i": [[0, 0], [28.157, -33.619]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 59, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [32.494, -33.716]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 60, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [36.491, -33.805]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 61, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [40.103, -33.885]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 62, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [43.283, -33.955]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 63, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [45.986, -34.016]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 64, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [48.168, -34.064]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 65, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [49.783, -34.1]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 66, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [50.785, -34.122]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 67, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [51.129, -34.13]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 68, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [50.737, -34.121]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 69, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [49.596, -34.096]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 70, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [47.762, -34.055]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 71, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [45.291, -34]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 72, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [42.238, -33.932]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 73, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [38.658, -33.853]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 74, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [34.607, -33.763]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 75, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [30.141, -33.664]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 76, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [25.314, -33.556]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 77, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [20.182, -33.442]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 78, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [14.801, -33.323]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 79, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [9.226, -33.199]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 80, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [3.512, -33.072]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 81, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-2.284, -32.943]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 82, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-8.109, -32.814]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 83, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-13.906, -32.685]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 84, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-19.619, -32.558]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 85, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-25.194, -32.434]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 86, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-30.575, -32.315]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 87, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-35.707, -32.201]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 88, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-40.534, -32.094]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 89, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-45, -31.994]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 90, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-49.051, -31.904]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 91, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-52.631, -31.825]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 92, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-55.684, -31.757]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 93, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-58.155, -31.702]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 94, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-59.989, -31.661]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 95, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.13, -31.636]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 96, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.522, -31.627]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 97, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.178, -31.635]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 98, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-60.176, -31.657]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 99, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-58.562, -31.693]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 100, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-56.38, -31.742]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 101, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-53.676, -31.802]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 102, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-50.496, -31.872]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 103, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-46.885, -31.952]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 104, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-42.888, -32.041]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 105, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-38.55, -32.138]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 106, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-33.918, -32.241]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 107, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-29.036, -32.349]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 108, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-23.95, -32.462]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 109, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-18.706, -32.578]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 110, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-13.347, -32.697]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 111, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-7.921, -32.818]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 112, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-2.472, -32.939]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 113, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [2.954, -33.06]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 114, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [8.312, -33.179]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 115, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [13.557, -33.295]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 116, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [18.643, -33.408]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 117, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [23.525, -33.517]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 118, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }]
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 30, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Shape 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }], "ip": 0, "op": 180, "st": 0, "bm": 0
    }, {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Foot Left",
        "parent": 6,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "k": [{"s": [-4.821], "t": 59, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-2.488],
                    "t": 60,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-0.121], "t": 61, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [2.257],
                    "t": 62,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [4.624], "t": 63, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [6.957],
                    "t": 64,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [9.234], "t": 65, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [11.431],
                    "t": 66,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [13.527], "t": 67, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [15.498],
                    "t": 68,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [17.322], "t": 69, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [18.976],
                    "t": 70,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [20.437], "t": 71, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.684],
                    "t": 72,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [22.693], "t": 73, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [23.442],
                    "t": 74,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [23.908], "t": 75, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [24.068],
                    "t": 76,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [23.928], "t": 77, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [23.518],
                    "t": 78,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [22.859], "t": 79, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.968],
                    "t": 80,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [20.864], "t": 81, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [19.566],
                    "t": 82,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [18.091], "t": 83, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [16.459],
                    "t": 84,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [14.688], "t": 85, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [12.796],
                    "t": 86,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [10.803], "t": 87, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [8.726],
                    "t": 88,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [6.584], "t": 89, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [4.396],
                    "t": 90,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [2.181], "t": 91, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-0.044],
                    "t": 92,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-2.26], "t": 93, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-4.448],
                    "t": 94,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-6.59], "t": 95, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-8.667],
                    "t": 96,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-10.66], "t": 97, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-12.552],
                    "t": 98,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-14.323], "t": 99, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-15.955],
                    "t": 100,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-17.429], "t": 101, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.728],
                    "t": 102,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-19.832], "t": 103, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-20.723],
                    "t": 104,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.382], "t": 105, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-21.791],
                    "t": 106,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.932], "t": 107, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-21.772],
                    "t": 108,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.306], "t": 109, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-20.557],
                    "t": 110,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-19.548], "t": 111, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.301],
                    "t": 112,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-16.839], "t": 113, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-15.185],
                    "t": 114,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-13.361], "t": 115, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-11.39],
                    "t": 116,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-9.295], "t": 117, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-7.098],
                    "t": 118,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }]
            },
            "p": {"a": 0, "k": [-66.949, 288.907, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [-371, 223.5, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[-410, 226.5], [-370, 222]], "c": false},
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 30, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0, "ind": 6, "ty": 4, "nm": "Leg Left", "parent": 9, "sr": 1, "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "k": [{"s": [-6.185], "t": 59, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-2.068],
                    "t": 60,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [2.068], "t": 61, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [6.185],
                    "t": 62,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [10.242], "t": 63, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [14.201],
                    "t": 64,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [18.023], "t": 65, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [21.667],
                    "t": 66,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [25.095], "t": 67, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [28.267],
                    "t": 68,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [31.144], "t": 69, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [33.686],
                    "t": 70,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [35.854], "t": 71, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [37.609],
                    "t": 72,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [38.911], "t": 73, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [39.721],
                    "t": 74,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [40], "t": 75, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [39.739],
                    "t": 76,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [38.981], "t": 77, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [37.76],
                    "t": 78,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [36.113], "t": 79, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [34.074],
                    "t": 80,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [31.68], "t": 81, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [28.966],
                    "t": 82,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [25.967], "t": 83, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [22.72],
                    "t": 84,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [19.259], "t": 85, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [15.621],
                    "t": 86,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [11.84], "t": 87, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [7.953],
                    "t": 88,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [3.994], "t": 89, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-3.994],
                    "t": 91,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-7.953], "t": 92, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-11.84],
                    "t": 93,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-15.621], "t": 94, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-19.259],
                    "t": 95,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-22.72], "t": 96, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-25.967],
                    "t": 97,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-28.966], "t": 98, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-31.68],
                    "t": 99,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-34.074], "t": 100, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-36.113],
                    "t": 101,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-37.76], "t": 102, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-38.981],
                    "t": 103,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-39.739], "t": 104, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-40],
                    "t": 105,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-39.721], "t": 106, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-38.911],
                    "t": 107,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-37.609], "t": 108, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-35.854],
                    "t": 109,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-33.686], "t": 110, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-31.144],
                    "t": 111,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-28.267], "t": 112, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-25.095],
                    "t": 113,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-21.667], "t": 114, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-18.023],
                    "t": 115,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-14.201], "t": 116, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}, {
                    "s": [-10.242],
                    "t": 117,
                    "i": {"x": [1], "y": [1]},
                    "o": {"x": [0], "y": [0]}
                }, {"s": [-6.185], "t": 118, "i": {"x": [1], "y": [1]}, "o": {"x": [0], "y": [0]}}]
            },
            "p": {"a": 0, "k": [-66, 167, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [-66, 167, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        }, "ao": 0, "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "k": [{
                        "s": [{
                            "i": [[0, 0], [-29.036, -32.349]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 59, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-23.95, -32.462]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 60, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-18.706, -32.578]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 61, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-13.347, -32.697]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 62, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-7.921, -32.818]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 63, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-2.472, -32.939]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 64, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [2.954, -33.06]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 65, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [8.312, -33.179]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 66, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [13.557, -33.295]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 67, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [18.643, -33.408]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 68, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [23.525, -33.517]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 69, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [28.157, -33.619]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 70, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [32.494, -33.716]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 71, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [36.491, -33.805]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 72, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [40.103, -33.885]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 73, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [43.283, -33.955]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 74, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [45.986, -34.016]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 75, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [48.168, -34.064]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 76, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [49.783, -34.1]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 77, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [50.785, -34.122]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 78, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [51.129, -34.13]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 79, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [50.737, -34.121]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 80, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [49.596, -34.096]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 81, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [47.762, -34.055]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 82, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [45.291, -34]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 83, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [42.238, -33.932]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 84, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [38.658, -33.853]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 85, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [34.607, -33.763]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 86, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [30.141, -33.664]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 87, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [25.314, -33.556]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 88, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [20.182, -33.442]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 89, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [14.801, -33.323]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 90, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [9.226, -33.199]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 91, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [3.512, -33.072]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 92, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-2.284, -32.943]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 93, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-8.109, -32.814]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 94, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-13.906, -32.685]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 95, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-19.619, -32.558]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 96, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-25.194, -32.434]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 97, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-30.575, -32.315]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 98, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-35.707, -32.201]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 99, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-40.534, -32.094]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 100, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-45, -31.994]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 101, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-49.051, -31.904]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 102, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-52.631, -31.825]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 103, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-55.684, -31.757]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 104, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-58.155, -31.702]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 105, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-59.989, -31.661]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 106, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.13, -31.636]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 107, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.522, -31.627]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 108, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-61.178, -31.635]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 109, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-60.176, -31.657]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 110, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-58.562, -31.693]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 111, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-56.38, -31.742]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 112, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-53.676, -31.802]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 113, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-50.496, -31.872]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 114, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-46.885, -31.952]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 115, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-42.888, -32.041]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 116, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-38.55, -32.138]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 117, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }, {
                        "s": [{
                            "i": [[0, 0], [-33.918, -32.241]],
                            "o": [[0, 40.667], [61.522, 31.627]],
                            "v": [[-67, 165], [-67, 287]],
                            "c": false
                        }], "t": 118, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}
                    }]
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 30, "ix": 5},
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Shape 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }], "ip": 0, "op": 180, "st": 0, "bm": 0
    }, {
        "ddd": 0,
        "ind": 7,
        "ty": 4,
        "nm": "Mouth",
        "parent": 8,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [-6.752, 28.826, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [88, 88, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 60,
                        "s": [{
                            "i": [[0, 0], [-44.765, -49.458]],
                            "o": [[0, 0], [94.048, 103.907]],
                            "v": [[-42, 42.5], [49.5, 42.5]],
                            "c": false
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 90,
                        "s": [{
                            "i": [[0, 0], [-57.66, -26.063]],
                            "o": [[0, 0], [67.335, 30.437]],
                            "v": [[-42, 42.5], [49.5, 42.5]],
                            "c": false
                        }]
                    }, {
                        "t": 119,
                        "s": [{
                            "i": [[0, 0], [-44.765, -49.458]],
                            "o": [[0, 0], [94.048, 103.907]],
                            "v": [[-42, 42.5], [49.5, 42.5]],
                            "c": false
                        }]
                    }],
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "t": 60,
                        "s": [15]
                    }, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 90, "s": [20]}, {
                        "t": 119,
                        "s": [15]
                    }],
                    "ix": 5
                },
                "lc": 2,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 8,
        "ty": 4,
        "nm": "Eyes",
        "parent": 9,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11}, "r": {"a": 0, "k": 0, "ix": 10}, "p": {
                "k": [{"s": [1.984, 0, 0], "t": 59, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-2, 0, 0],
                    "t": 61,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-3.975, 0, 0], "t": 62, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-5.917, 0, 0],
                    "t": 63,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-7.809, 0, 0], "t": 64, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-9.63, 0, 0],
                    "t": 65,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-11.358, 0, 0], "t": 66, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-12.98, 0, 0],
                    "t": 67,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-14.481, 0, 0], "t": 68, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-15.84, 0, 0],
                    "t": 69,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-17.038, 0, 0], "t": 70, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-18.061, 0, 0],
                    "t": 71,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-18.889, 0, 0], "t": 72, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-19.499, 0, 0],
                    "t": 73,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-19.873, 0, 0], "t": 74, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-20, 0, 0],
                    "t": 75,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-19.873, 0, 0], "t": 76, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-19.499, 0, 0],
                    "t": 77,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-18.889, 0, 0], "t": 78, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-18.061, 0, 0],
                    "t": 79,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-17.038, 0, 0], "t": 80, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-15.84, 0, 0],
                    "t": 81,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-14.481, 0, 0], "t": 82, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-12.98, 0, 0],
                    "t": 83,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-11.358, 0, 0], "t": 84, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-9.63, 0, 0],
                    "t": 85,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-7.809, 0, 0], "t": 86, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-5.917, 0, 0],
                    "t": 87,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [-3.975, 0, 0], "t": 88, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [-2, 0, 0],
                    "t": 89,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [1.984, 0, 0], "t": 91, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [3.962, 0, 0],
                    "t": 92,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [5.91, 0, 0], "t": 93, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [7.806, 0, 0],
                    "t": 94,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [9.63, 0, 0], "t": 95, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [11.359, 0, 0],
                    "t": 96,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [12.983, 0, 0], "t": 97, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [14.483, 0, 0],
                    "t": 98,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [15.838, 0, 0], "t": 99, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [17.036, 0, 0],
                    "t": 100,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [18.056, 0, 0], "t": 101, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [18.878, 0, 0],
                    "t": 102,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [19.489, 0, 0], "t": 103, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [19.87, 0, 0],
                    "t": 104,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [20, 0, 0], "t": 105, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [19.87, 0, 0],
                    "t": 106,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [19.489, 0, 0], "t": 107, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [18.878, 0, 0],
                    "t": 108,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [18.056, 0, 0], "t": 109, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [17.036, 0, 0],
                    "t": 110,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [15.838, 0, 0], "t": 111, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [14.483, 0, 0],
                    "t": 112,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [12.983, 0, 0], "t": 113, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [11.359, 0, 0],
                    "t": 114,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [9.63, 0, 0], "t": 115, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [7.806, 0, 0],
                    "t": 116,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }, {"s": [5.91, 0, 0], "t": 117, "i": {"x": 1, "y": 1}, "o": {"x": 0, "y": 0}}, {
                    "s": [3.962, 0, 0],
                    "t": 118,
                    "i": {"x": 1, "y": 1},
                    "o": {"x": 0, "y": 0}
                }], "l": 2
            }, "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2}, "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ty": "rc",
                "d": 1,
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833], "y": [1, 0.833]},
                        "o": {"x": [0.333, 0.333], "y": [0, 0]},
                        "t": 71,
                        "s": [60, 60]
                    }, {
                        "i": {"x": [0.667, 0.667], "y": [1, 1]},
                        "o": {"x": [0.167, 0.167], "y": [0, 0.167]},
                        "t": 75,
                        "s": [60, 0]
                    }, {"t": 79, "s": [60, 60]}],
                    "ix": 2
                },
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "r": {"a": 0, "k": 60, "ix": 4},
                "nm": "Rectangle Path 1",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.164705882353, 0.164705882353, 0.164705882353, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [50, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Eye Right",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ty": "rc",
                "d": 1,
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833], "y": [1, 0.833]},
                        "o": {"x": [0.333, 0.333], "y": [0, 0]},
                        "t": 71,
                        "s": [60, 60]
                    }, {
                        "i": {"x": [0.667, 0.667], "y": [1, 1]},
                        "o": {"x": [0.167, 0.167], "y": [0, 0.167]},
                        "t": 75,
                        "s": [60, 0]
                    }, {"t": 79, "s": [60, 60]}],
                    "ix": 2
                },
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "r": {"a": 0, "k": 60, "ix": 4},
                "nm": "Rectangle Path 1",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.164705882353, 0.164705882353, 0.164705882353, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [-50, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Eye Left",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 9,
        "ty": 4,
        "nm": "Ball",
        "parent": 10,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [0, 0, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [400, 400], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "nm": "Ellipse Path 1",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Ellipse 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "String",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "a": 1,
                "k": [{"i": {"x": [0.5], "y": [1]}, "o": {"x": [0.5], "y": [0]}, "t": 60, "s": [20]}, {
                    "i": {
                        "x": [0.5],
                        "y": [1]
                    }, "o": {"x": [0.5], "y": [0]}, "t": 90, "s": [-20]
                }, {"t": 119, "s": [20]}],
                "ix": 10
            },
            "p": {"a": 0, "k": [540, -8, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [0, -548, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {"i": [[0, 0], [0, 5]], "o": [[0, 0], [0, -5]], "v": [[0, -540], [0, -180]], "c": true},
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.2901960784313726, 0.5647058823529412, 0.8862745098039215, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 5, "ix": 5},
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Shadow",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 25, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.5, "y": 1},
                    "o": {"x": 0.5, "y": 0},
                    "t": 60,
                    "s": [340, 960, 0],
                    "to": [66.667, 0, 0],
                    "ti": [0, 0, 0]
                }, {
                    "i": {"x": 0.5, "y": 1},
                    "o": {"x": 0.5, "y": 0},
                    "t": 90,
                    "s": [740, 960, 0],
                    "to": [0, 0, 0],
                    "ti": [66.667, 0, 0]
                }, {"t": 119, "s": [340, 960, 0]}],
                "ix": 2,
                "l": 2
            },
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2},
            "s": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                    "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                    "t": 60,
                    "s": [90, 90, 100]
                }, {
                    "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                    "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                    "t": 75,
                    "s": [110, 110, 100]
                }, {
                    "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                    "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                    "t": 90,
                    "s": [90, 90, 100]
                }, {
                    "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                    "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                    "t": 105,
                    "s": [110, 110, 100]
                }, {"t": 119, "s": [90, 90, 100]}],
                "ix": 6,
                "l": 2
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [300, 50], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "nm": "Ellipse Path 1",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.211764705882, 0.211764705882, 0.211764705882, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Ellipse 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 180,
        "st": 0,
        "bm": 0
    }],
    "markers": [{"tm": 60, "cm": "Start", "dr": 0}, {"tm": 120, "cm": "End", "dr": 0}]
}